// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cxcOJ","content":"styles_content__201QX"};